module.exports = __webpack_public_path__ + "media/images/pt/approach-segment-e943c1cc8ae895e2947eb870c5088e2a.jpg";